import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  { path: '*', redirect: '/home' },
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "chunk-5149d1bd" */ '@/views/Home.vue'),
  },
  {
    path: '/behandelingen',
    name: 'behandelingen',
    component: () => import(/* webpackChunkName: "chunk-2d20ef08" */ '@/views/Behandelingen.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackChunkName: "chunk-45db24f3" */ '@/views/Contact.vue'),
  },
  {
    path: '/prijzen',
    name: 'Prijzen',
    component: () => import(/* webpackChunkName: "chunk-2d0d3d87" */ '@/views/Prijzen.vue'),
  },
];

const router = new VueRouter({
  base: '/',
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes,
});

router.beforeEach((to, from, next) => {
  console.debug('routing from ', from.fullPath, to.query);
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    console.debug('routing to secured ', to.fullPath);
  } else {
    console.debug('routing to unsecured route', to.fullPath);
    next();
  }
});

export default router;
